/* New Home swatch behavior — theme asset (Horizon strips inline section <script>).
   Event delegation. Updates srcset (not just src) because the <img> uses srcset,
   which the browser renders from and which overrides src. */
(function(){
  function apply(card, btn){
    var img=card.querySelector('.nh-img'); if(!img) return;
    var s600=btn.getAttribute('data-img');
    var s1000=btn.getAttribute('data-full')||s600;
    if(!s600) return;
    img.srcset=s600+' 600w, '+s1000+' 1000w';
    img.src=s600;
  }
  function onOver(e){
    var t=e.target; if(!t.closest) return;
    var btn=t.closest('#new-home .nh-sw'); if(!btn) return;
    var card=btn.closest('.nh-card'); if(!card) return;
    apply(card, btn);
  }
  function onClick(e){
    var t=e.target; if(!t.closest) return;
    var btn=t.closest('#new-home .nh-sw'); if(!btn) return;
    e.preventDefault();
    var card=btn.closest('.nh-card'); if(!card) return;
    apply(card, btn);
    var sws=card.querySelectorAll('.nh-sw');
    for(var i=0;i<sws.length;i++) sws[i].classList.remove('nh-sw--on');
    btn.classList.add('nh-sw--on');
  }
  function onEnterCapture(e){
    var t=e.target; if(!t.closest) return;
    var card=t.closest('#new-home .nh-card'); if(!card) return;
    if(card._warmed) return; card._warmed=true;
    var sws=card.querySelectorAll('.nh-sw');
    for(var i=0;i<sws.length;i++){
      var u600=sws[i].getAttribute('data-img');
      var u1000=sws[i].getAttribute('data-full');
      [u600,u1000].forEach(function(u){
        if(!u) return;
        var im=new Image(); im.decoding='async'; if('fetchPriority' in im) im.fetchPriority='low'; im.src=u; if(im.decode){ im.decode().catch(function(){}); }
      });
    }
  }
  function onOut(e){
    var t=e.target; if(!t.closest) return;
    var btn=t.closest('#new-home .nh-sw'); if(!btn) return;
    var card=btn.closest('.nh-card'); if(!card) return;
    // if moving to another swatch, that swatch's mouseover handles it; only revert when leaving the swatches
    var to=e.relatedTarget;
    if(to && to.closest && to.closest('#new-home .nh-sw')) return;
    var sel=card.querySelector('.nh-sw.nh-sw--on');
    if(sel) apply(card, sel);
  }
  function wire(){
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    document.addEventListener('click', onClick);
    document.addEventListener('pointerenter', onEnterCapture, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();